module.exports = __webpack_public_path__ + "img/sensitivity-icon-1.87feef39.svg";